import './assets/main.css'

const urlParams = new URLSearchParams(window.location.search)
const isSlimExperience = urlParams.get('slimExperience') === 'true'

if (isSlimExperience) {
  import('./slim-main')
} else {
  import('./app-main')
}
